import Link, { LinkProps } from 'next/link';
import { AnchorHTMLAttributes, forwardRef } from 'react';

import { useHrefWithLocale } from './useHrefWithLocale';

interface NextLinkWithLocaleProps
  extends LinkProps,
    Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> {
  disabled?: boolean;
}

const NextLinkWithLocale = forwardRef<
  HTMLAnchorElement,
  NextLinkWithLocaleProps
>(({ children, href, disabled, ...rest }, ref) => {
  const hrefWithLocale = useHrefWithLocale(href, rest.locale);

  if (disabled) {
    return <>{children}</>;
  }

  return (
    <Link {...rest} href={hrefWithLocale} ref={ref}>
      {children}
    </Link>
  );
});

NextLinkWithLocale.displayName = 'NextLinkWithLocale';

export default NextLinkWithLocale;
